// extracted by mini-css-extract-plugin
export default {"formHeading":"TI-z","form":"UI-z","submitBtn":"VI-z","disabled":"WI-z","input":"XI-z","error":"YI-z","submitMsg":"ZI-z","signIn":"_I-z"};